/**
 * <MainContainer
 *		// please describe props here
 *	/>
 *
 * This is ...
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { fetchSchoolDetail, clearSchoolDetail} from './ducks/school-detail';
import getMenuItems, { fullScreenPath, invalidUserAllowedPath } from './get-menu-items';
import SideMenu from './SideMenu';
import Header from './Header';
import { getSubscription } from './ducks/subscription';
import NoPermission from 'containers/pages/NoPermission';
import ChangeSchool from 'containers/pages/ChangeSchool';
import AccountSettings from 'containers/pages/AccountSettings';
import PrivacyCN from 'containers/pages/PrivacyPolicy/cn';
import PrivacyEN from 'containers/pages/PrivacyPolicy/en';
import getSubscriptionCtrl from 'controllers/payment/getSubscription'
import { routesObj } from 'routes';
import { isValidUser, isBasicUser, isOnlyTeacher } from 'containers/__R';
import locale from './locale';

const NO_SUCH_ROUTE = 'NO_SUCH_ROUTE';
const USER_NOT_LOADED = 'USER_NOT_LOADED';
const HAS_PERMISSION = 'HAS_PERMISSION';
const NO_PERMISSION = 'NO_PERMISSION';
const PAGE_HAS_NO_RESTRICTION = 'PAGE_HAS_NO_RESTRICTION';
const NOT_FOR_BASIC_USER = 'NOT_FOR_BASIC_USER';
const mapStateToProps = state => ({
  schoolDetail: state.schoolDetail.detail || {},
  subscription: state.gSubscription.result || {},
  user: state.user,
});

const mapDispatchToProps = dispatch => {
  return {
    fetchSchoolDetail: (schoolId) => dispatch(fetchSchoolDetail(schoolId)),
    getSubscription: (schoolId) => dispatch(getSubscription(schoolId)),
    clearSchoolDetail: () => dispatch(clearSchoolDetail()),
  };
};

const SEARCH_TIMEOUT = 500;

class MainContainer extends React.Component {
  constructor(props) {
    super(props);

    const sideMenuHidden = localStorage.getItem('_ct_menu_hidden') == "true";

    this.state = {
      noSideMenu: true,
      searchText: '',
      searchActive: false,
      sideMenuHidden,
    };

    this.onMenuLoad = this.onMenuLoad.bind(this);
    this.onSearchClear = this.onSearchClear.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onSearchFocus = this.onSearchFocus.bind(this);
    this.unfocusSearch = this.unfocusSearch.bind(this);
    this.registerMainContent = this.registerMainContent.bind(this);

    this.toggleSideMenu = this.toggleSideMenu.bind(this);
  }

  componentWillMount() {
    this.menus = getMenuItems();
    const schoolId = localStorage.getItem('schoolId')
    if (schoolId) {
      this.props.getSubscription(schoolId);
      this.setRefreshingSubscription();
    }
  }

  componentDidMount() {
    const schoolId = localStorage.getItem('schoolId');

    if (schoolId) {
      this.props.fetchSchoolDetail(schoolId);
    }
  }
  setRefreshingSubscription(){
    if(!global['--subscription-refresher']){
      global['--subscription-refresher'] = setInterval(()=> {
        const schoolId = localStorage.getItem('schoolId');
        getSubscriptionCtrl(schoolId)
          .then((res)=> {
            if(!res.data.is_valid){
              window.location.href = '/'
            }else {
              this.props.getSubscription(schoolId)
            }
          })
      }, 3600000)
    }
  }
  registerMainContent(ref) {
    if (ref) {
      global['--classtop-main-section'] = ref;
    }
  }

  onMenuLoad() {
  }

  unfocusSearch() {
    this.setState({
      searchActive: false,
    });
  }

  onSearchFocus() {
    const { searchText } = this.state;

    this.setState({
      searchActive: searchText.length >= 3,
    });
  }

  onSearchChange(e) {
    const searchText = e.target.value;

    this.setState({
      searchText,
      searchActive: false,
    });

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(()=>{
      this.setState({
        searchText,
        searchActive: searchText.length >= 3,
      });
    }, SEARCH_TIMEOUT);

  }

  onSearchClear() {
    this.setState({
      searchText: '',
      searchActive: false,
    });
  }

  toggleSideMenu() {
    const sideMenuHidden = this.state.sideMenuHidden !== true;

    localStorage.setItem('_ct_menu_hidden', sideMenuHidden)

    this.setState({
      sideMenuHidden,
    });
  }

  getContent(activePath) {
    if(!isValidUser() && !isOnlyTeacher()){
      if(activePath === '/'){
        return <ChangeSchool />
      }else if (activePath ==='/account-settings'){
        return <AccountSettings />;
      }else if (activePath ==='/privacy-en'){
        return <PrivacyEN />;
      }else if (activePath ==='/privacy-cn'){
        return <PrivacyCN />;
      }
    }
    const result = this.getPagePermission();
    switch (result) {
      case NO_SUCH_ROUTE: {
        return <span />
      }
      case USER_NOT_LOADED: {
        return <span />
      }
      case NOT_FOR_BASIC_USER: {
        return <div className='upgrade-plan'>{__('Please upgrade to higher subscription plan to unlock this feature', locale)}</div>
      }
      case PAGE_HAS_NO_RESTRICTION: {
        return this.props.children;
      }
      case HAS_PERMISSION: {
        return this.props.children;
      }
      case NO_PERMISSION: {
        return <NoPermission />
      }
    }
  }

  getPagePermission() {
    const {
      user,
      routes
    } = this.props;

    const { path } = routes[1];

    const route = routesObj[path];

    if (!route) {
      return NO_SUCH_ROUTE
    }

    //
    // Check if user has permission to view the page
    //
    const { permissionRequired,  notForBasicUser} = route;

    if (user.loaded !== true) {
      return USER_NOT_LOADED // user not loaded don't show anything
    }
    const schoolId = localStorage.getItem('schoolId');

    if(isBasicUser() && notForBasicUser) {
      return NOT_FOR_BASIC_USER;
    }
    let hasPermission = false;

    if (typeof permissionRequired == 'undefined') {
      return PAGE_HAS_NO_RESTRICTION;
    }

    if (user.loaded &&
        Object.keys(user.rolesPerSchool).length > 0 &&
        schoolId &&
        typeof user.rolesPerSchool[schoolId] !== 'undefined') {

      const schoolRole = user.rolesPerSchool[schoolId];

      if (schoolRole.role == 'school_owner') {
         hasPermission = true
      } else {
        let hasAllPermission = true;

        // if missing permission all fails
        permissionRequired.map((perm)=>{
          if (schoolRole.permissions.indexOf(perm) == -1) {
            hasAllPermission = false;
          }
        });

        hasPermission = hasAllPermission;
      }
    }

    return hasPermission == true ? HAS_PERMISSION : NO_PERMISSION;
  }

  render() {

    const {
      user,
      subscription,
      schoolDetail,
      routes
    } = this.props;

    const {
      noSideMenu,
      searchText,
      searchActive,
      sideMenuHidden,
    } = this.state;

    const Collapsed = false; // implement it later
    
    let activePath = '';
    if(!isValidUser() && (user.result.school_amount - user.result.school_owned_amount)<1){
      if(invalidUserAllowedPath.indexOf(routes[1].path) !== -1){
        activePath = routes[1].path;
      }else {
        activePath = '/';
      }
    }else {
      activePath = routes[1].path;
    }
    const Content = this.getContent(activePath);
    return (
      <div className={classnames('MainContainer', { noSideMenu: fullScreenPath.indexOf(activePath) > -1, sideMenuHidden })}>
        { fullScreenPath.indexOf(activePath) === -1 &&
          <SideMenu
            menus={this.menus}
            activePath={activePath}
            onMenuLoad={this.onMenuLoad}
            subscription={this.props.subscription}

            toggleSideMenu={this.toggleSideMenu}
            sideMenuHidden={sideMenuHidden}
          />
        }
        <Header
          user={user.result}
          schoolDetail={schoolDetail}
          onSearchChange={this.onSearchChange}
          onSearchClear={this.onSearchClear}
          onSearchFocus={this.onSearchFocus}
          searchText={searchText}
          searchActive={searchActive}
        />
        { searchActive &&
          <div className='searchOverlay' onClick={this.unfocusSearch}></div>
        }
        <div className='Content' ref={this.registerMainContent}>
          {Content}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);



// WEBPACK FOOTER //
// ./src/containers/Main/MainContainer.js